export enum EPhoneUpdateSteps {
  Step1 = 'phoneCheckOld',
  Step2 = 'phoneConfirmOld',
  Step3 = 'phoneCheckNew',
  Step4 = 'phoneConfirmNew',
}
